// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseAiAgentConfigFoundResponse } from '../../types';

/**
 * my
 *
 * @export
 * @tags Coze智能体
 * @link [GET] /aiAgentConfigs/my
 */
export function getAiAgentConfigsMy(): Promise<BaseResponseAiAgentConfigFoundResponse>;
export function getAiAgentConfigsMy(
    options: ApiOptions<never, never>
): Promise<BaseResponseAiAgentConfigFoundResponse>;
export function getAiAgentConfigsMy(
    options?: ApiOptions<never, never>
): Promise<BaseResponseAiAgentConfigFoundResponse> {
    return request<never, never, never>('/aiAgentConfigs/my', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgentConfigsMy',
    });
}

export const meta = [{ tags: ['Coze智能体'], path: '/aiAgentConfigs/my', method: 'get' }];
